import { render, staticRenderFns } from "./UIElements.vue?vue&type=template&id=451f7c28&"
import script from "./UIElements.vue?vue&type=script&lang=ts&"
export * from "./UIElements.vue?vue&type=script&lang=ts&"
import style0 from "./UIElements.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports